import { render, staticRenderFns } from "./su-title.vue?vue&type=template&id=dab10214&scoped=true"
import script from "./su-title.vue?vue&type=script&lang=js"
export * from "./su-title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab10214",
  null
  
)

export default component.exports